import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Table } from 'primeng/table';
import { DataService } from '../services/data.service';

@Component({
  selector: 'app-tprep-list',
  templateUrl: './tprep-list.component.html',
  styleUrls: ['./tprep-list.component.css']
})
export class TprepListComponent {

  @ViewChild('dt') dt: Table | undefined;

  tpreplist: any[] = [];
  loading: boolean = true;
  selectedSample: any;
  cols: any[] = [];

  constructor(private dataService: DataService,
    private router: Router) { }

  ngOnInit() {
    const filters = localStorage.getItem("filters");

    this.dataService.getTPrepList().then(data => {
      this.tpreplist = data;
      this.loading = false;
    });

    this.cols = [
      { field: 'instrument', header: 'Instrument' },
      { field: 'plvPlate', header: 'PLV Plate' },
      { field: 'tip', header: 'Tip' },
      { field: 'startDate', header: 'Start Date' },
      { field: 'tPrepIncident', header: 'TPrep Incident' },
      { field: 'tPrepIncidentDate', header: 'TPrep Incident Date' },
      { field: 'tPrepService', header: 'TPrep Service' },
      { field: 'tPrepServiceDate', header: 'TPrep Service Date' }
    ];
  }

  clear(table: Table) {
      table.clear();
  }

  applyFilterGlobal($event:any, stringVal:any) {
    this.dt?.filterGlobal(($event.target as HTMLInputElement).value, stringVal);
  }

  rowClick(record: any){
    //this.router.navigate(['detail',snpRecord.sampleId]);
  }
}
